import { render, staticRenderFns } from "./flowRedirect.vue?vue&type=template&id=55675178&scoped=true"
import script from "./flowRedirect.vue?vue&type=script&lang=js"
export * from "./flowRedirect.vue?vue&type=script&lang=js"
import style0 from "./flowRedirect.vue?vue&type=style&index=0&id=55675178&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55675178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55675178')) {
      api.createRecord('55675178', component.options)
    } else {
      api.reload('55675178', component.options)
    }
    module.hot.accept("./flowRedirect.vue?vue&type=template&id=55675178&scoped=true", function () {
      api.rerender('55675178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/flowRedirect.vue"
export default component.exports